exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/**\n  Progress bar scss\n */\n.progress {\n  background-color: #333333; }\n  .progress .progress-bar.title-yellow {\n    background-color: #DFD000; }\n  .progress .progress-bar.title-red {\n    background-color: #8E0014; }\n  .progress .progress-bar.title-blue {\n    background-color: #4e67a3; }\n  .progress .progress-bar.title-green {\n    background-color: #69CA00; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/resume/progress-bars.component.scss
// module id = 389
// module chunks = 1